import _ from 'lodash'

function capitalize(string) {
    return string.replace(
        /\w\S*/g,
        function(txt){
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        });
}

function ucfirst(string) {
    return string[0].toUpperCase() + string.slice(1).toLowerCase()
}

function trans(index) {
    return _.get(window.i18n, index)
}

export {
    capitalize,
    ucfirst,
    trans,
}